<template>
  <v-data-table
    :headers="headers"
    :items="recipeVerifications"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="RecipeVerification-button-new"
          @click="$router.push({
            name: 'recipe-verification-EditRecipeVerification'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'recipe-verification-EditRecipeVerification',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListRecipeVerification',
  module: 'RecipeVerification',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('recipeVerifications', ['recipeVerifications']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('date'),
          value: 'date',
        },
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('recipe'),
          value: 'recipe',
        },
        {
          text: this.$$t('brandingCode'),
          value: 'brandingCode',
        },
        {
          text: this.$$t('country'),
          value: 'country',
        },
        {
          text: this.$$t('asia'),
          value: 'asia',
        },
        {
          text: this.$$t('other'),
          value: 'other',
        },
        {
          text: this.$$t('bestBefore'),
          value: 'bestBefore',
        },
        {
          text: this.$$t('canningCode'),
          value: 'canningCode',
        },
        {
          text: this.$$t('product'),
          value: 'product',
        },
        {
          text: this.$$t('pouch'),
          value: 'pouch',
        },
        {
          text: this.$$t('can'),
          value: 'can',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_recipeVerifications();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('recipeVerifications', ['LOAD_recipeVerifications', 'DELETE_recipeVerification']),
    /** Delete RecipeVerification from the collection
     */
    async remove(RecipeVerification) {
      this.isLoading = true;
      await this.DELETE_RecipeVerification(RecipeVerification);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# RecipeVerification example

'''js
<RecipeVerification />
'''
</docs>
